import { render, staticRenderFns } from "./procedures-editor-contract.vue?vue&type=template&id=fe865896"
import script from "./procedures-editor-contract.vue?vue&type=script&lang=js"
export * from "./procedures-editor-contract.vue?vue&type=script&lang=js"
import style0 from "./procedures-editor-contract.vue?vue&type=style&index=0&id=fe865896&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports